import React from 'react';
import {
    Header,
    Grid, Segment,
    Button,
    Icon, Form, Dropdown, Table, Popup
} from 'semantic-ui-react';
import { ToastContainer, toast } from 'react-toastify';
import axios from 'axios';
import { FormattedMessage } from 'react-intl';


import ActivePollList from '../AdminPoll/PollTabs/ActivePollList';


export default class PollList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            statuses: []

        };
    }

    componentWillMount() {
        // console.log('statusi se dobavljaju');
        axios.get('/questionnaire/get-statuses/')
            .then(res => {
                const statuses = res.data.map(el => ({
                    value: el.id,
                    key: el._key,
                    text: el.name
                }));
                this.setState({ statuses, loader: true });
            })
            .catch(err => {
                console.log('Failed to fetch poll statuses.');
            });

    }


    render() {
        return (

            <div>
                <Header as="h2"> Ankete </Header>
                <Segment.Group clearing raised >
                    <Segment> <Header as="h3"> Pregled anketa  </Header>
                    </Segment>
                    <Segment>
                        <p style={{ fontSize: '12px', fontWeight: 'bold' }}>
                            * Vaše učešće u anketi je potpuno dobrovoljno, a Vaši odgovori ostaju povjerljivi i anonimni.
                            Podaci prikupljeni anketom bit će prikazani samo kao statistički podaci.
                           Vaši iskreni i objektivni odgovori mogu biti indikator dobrih praksi ili ukazati na eventualne nedostatke i teškoće u procesu realizacije nastavnih aktivnosti te uticati na poboljšanje njihove buduće kvalitete.
                        </p>
                        {this.state.loader && <ActivePollList showCourse statuses={this.state.statuses} />}</Segment>
                </Segment.Group>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/views/Poll/StudentPoll/PollList.js